/* BestRest :: productkaarten per rij uitlijnen zonder lege ruimte

   Eerder reserveerden de kaarten vaste hoogte voor twee regels titel en twee regels
   subtekst, zodat specs, labels en prijs in een rij op gelijke hoogte stonden. Bij
   korte titels gaf dat lege ruimte. Dit script meet per zichtbare rij hoe hoog de
   hoogste titel en de hoogste subtekst zijn en zet alleen die hoogte als minimum.
   Staan alle titels op een regel, dan blijft er niets over. Werkt op elke pagina
   met kaarten (collectie, maatpagina's, homepage) en loopt opnieuw bij schalen,
   filteren en het laden van lettertypen. */
(function () {
  var VELDEN = ['.br-col__name', '.br-col__subline'];
  var bezig = false;

  function kaartenPerRij(kaarten) {
    var rijen = [];
    var vorigeTop = null;
    var rij = null;
    kaarten.forEach(function (kaart) {
      var top = Math.round(kaart.getBoundingClientRect().top);
      if (vorigeTop === null || Math.abs(top - vorigeTop) > 4) {
        rij = [];
        rijen.push(rij);
        vorigeTop = top;
      }
      rij.push(kaart);
    });
    return rijen;
  }

  function lijnUit() {
    var kaarten = Array.prototype.slice.call(document.querySelectorAll('.br-col__card')).filter(function (k) {
      return k.offsetParent !== null;
    });
    if (!kaarten.length) return;
    // eerst alles loslaten, anders meet je de vorige uitkomst
    kaarten.forEach(function (k) {
      VELDEN.forEach(function (sel) {
        var el = k.querySelector(sel);
        if (el) el.style.minHeight = '';
      });
    });
    kaartenPerRij(kaarten).forEach(function (rij) {
      if (rij.length < 2) return;
      VELDEN.forEach(function (sel) {
        var max = 0;
        var elementen = [];
        rij.forEach(function (k) {
          var el = k.querySelector(sel);
          if (!el) return;
          elementen.push(el);
          var h = el.getBoundingClientRect().height;
          if (h > max) max = h;
        });
        if (max > 0) {
          elementen.forEach(function (el) {
            el.style.minHeight = Math.ceil(max) + 'px';
          });
        }
      });
    });
  }

  function plan() {
    if (bezig) return;
    bezig = true;
    window.requestAnimationFrame(function () {
      bezig = false;
      lijnUit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', plan);
  } else {
    plan();
  }
  window.addEventListener('load', plan);
  window.addEventListener('resize', plan);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
  // filters en sorteren op de collectiepagina vervangen kaarten of verbergen ze;
  // alleen kijken naar de kaarten zelf en hun lijsten, niet naar stijlwijzigingen
  // (die zet dit script zelf, anders blijft het rondlopen)
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (lijst) {
      for (var i = 0; i < lijst.length; i++) {
        var m = lijst[i];
        var doel = m.target;
        if (!doel || !doel.classList) continue;
        var isKaartOfLijst = doel.classList.contains('br-col__item') || doel.classList.contains('br-col__card') || doel.classList.contains('br-col__grid') || doel.classList.contains('br-lp-showcase__grid');
        if (m.type === 'childList' && (isKaartOfLijst || doel.querySelector('.br-col__card'))) { plan(); return; }
        if (m.type === 'attributes' && isKaartOfLijst) { plan(); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }
})();
